export default __webpack_public_path__ + "static/media/zx7-in-person.7220af7b.png";